import { render, staticRenderFns } from "./DidNotRegister.vue?vue&type=template&id=4871628b&scoped=true&"
import script from "./DidNotRegister.vue?vue&type=script&lang=js&"
export * from "./DidNotRegister.vue?vue&type=script&lang=js&"
import style0 from "./DidNotRegister.vue?vue&type=style&index=0&id=4871628b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4871628b",
  null
  
)

export default component.exports